import { Box, IconButton, Typography } from '@mui/material'
import { IconCloudUpload, IconTrash } from '@tabler/icons-react'
import React, { useRef, useState } from 'react'
import RewardTip from '../../../../../components/leaderboard/RewardTip'

interface UploadReceiptProps {
  propName?: string
}

const UploadReceipt: React.FC<UploadReceiptProps> = ({ propName }) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [file, setFile] = useState<string>('')

  const handleFileChange = (event): void => {
    const file = event.target.files?.[0]

    if (!file) return

    const maxSize = 1024 * 1024
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']

    if (!allowedTypes.includes(file.type)) {
      alert('Only image files (JPEG, PNG, GIF, WEBP) are allowed.')
      return
    }

    if (file.size > maxSize) {
      alert('File size must be less than 1MB.')
      return
    }

    if (event?.target?.files && event?.target?.files?.[0]) {
      const file = event.target.files[0]
      const imageUrl = URL.createObjectURL(file)
      setFile(imageUrl)
    }
  }

  const handleClick = (): void => {
    fileInputRef.current?.click()
  }
  const handleResetImage = (): void => {
    setFile('')
  }
  return (
    <Box pb={4}>
      <RewardTip
        title="Get Points based on the amount you spent"
        sx={{ mt: 1, mb: 4 }}
      />
      {file ? (
        <Box display="flex" alignItems="stretch" mt={2} height="100%" gap={2}>
          <Box
            component="img"
            src={file}
            sx={{
              height: '198px',
              borderRadius: '8px',
              objectFit: 'cover',
              aspectRatio: 1,
            }}
          />

          <IconButton
            sx={{
              height: '28px',
            }}
            color="bordered"
            size="small"
            onClick={handleResetImage}
          >
            <IconTrash stroke={2} size={16} />
          </IconButton>
        </Box>
      ) : (
        <Box>
          <Typography variant="subtitle1" mb={1}>
            Receipt
          </Typography>

          <Box
            border={1}
            p={3}
            borderColor="grey.200"
            borderRadius="8px"
            textAlign="center"
            sx={{
              cursor: 'pointer',
            }}
            onClick={handleClick}
          >
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
            >
              <Box
                sx={{
                  height: '40px',
                  width: '40px',
                  borderRadius: '8px',
                  border: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderColor: 'grey.100',
                  mb: 1,
                }}
              >
                <IconCloudUpload stroke={2} size={20} />
              </Box>
              <Box>
                <Typography variant="body2" fontWeight="500">
                  Click to Upload{' '}
                  <Typography
                    component="span"
                    variant="subtitle1"
                    color="text.secondary"
                  >
                    or drag and drop
                  </Typography>
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" mt={0.5}>
                  JPG or PNG file only, Maximum 1 MB size
                </Typography>
              </Box>
            </Box>
          </Box>
          <Typography variant="subtitle2" color="text.secondary" mt={1}>
            We will verify and credit the points to your account.
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default UploadReceipt
